// extracted by mini-css-extract-plugin
export default {"linkButton":"LoginSection_linkButton__G91mj","linkButtonWrapper":"LoginSection_linkButtonWrapper__Fj3pf"};